.overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  grid-template-rows: auto 1fr;
  background: color-mix(in srgb, var(--surface-void) 96%, black);
  animation: fade 180ms var(--ease-out) both;
}

@keyframes fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .overlay { animation: none; }
}

.bar {
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  border-bottom: 1px solid var(--edge);
}

.counter,
.filename {
  font-family: var(--font-chrome);
  font-size: var(--step-0);
  letter-spacing: var(--track-tight);
  color: var(--ink-faint);
}

.filename {
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.barActions {
  display: flex;
  gap: var(--space-1);
}

.action {
  padding: 0.3rem 0.6rem;
  font-family: var(--font-chrome);
  font-size: 0.625rem;
  letter-spacing: var(--track-tight);
  text-transform: uppercase;
  color: var(--ink);
  background: var(--surface-panel);
  border: 1px solid var(--edge-strong);
  border-radius: var(--radius);
  cursor: pointer;
  transition: color 160ms var(--ease-out), border-color 160ms var(--ease-out);
}

.action:hover {
  color: var(--ink-bright);
  border-color: var(--ink-faint);
}

.menuWrap {
  position: relative;
}

.menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 12rem;
  display: flex;
  flex-direction: column;
  background: var(--surface-panel);
  border: 1px solid var(--edge-strong);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lift);
  overflow: hidden;
  z-index: 2;
}

.menuItem {
  padding: var(--space-2);
  font-size: var(--step-1);
  color: var(--ink);
  text-decoration: none;
  white-space: nowrap;
  transition: background 140ms var(--ease-out), color 140ms var(--ease-out);
}

.menuItem + .menuItem {
  border-top: 1px solid var(--edge);
}

.menuItem:hover {
  background: var(--surface-raised);
  color: var(--ink-bright);
}

.stage {
  grid-row: 2;
  margin: 0;
  display: grid;
  place-items: center;
  padding: var(--space-3);
  min-height: 0;
}

.media {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 3rem;
  height: 3rem;
  display: grid;
  place-items: center;
  font-size: 2rem;
  line-height: 1;
  color: var(--ink);
  background: color-mix(in srgb, var(--surface-panel) 70%, transparent);
  border: 1px solid var(--edge);
  border-radius: 50%;
  cursor: pointer;
  transition: opacity 160ms var(--ease-out), color 160ms var(--ease-out);
}

.arrow:hover:not(:disabled) {
  color: var(--ink-bright);
}

.arrow:disabled {
  opacity: 0.18;
  cursor: default;
}

.prev { left: var(--space-2); }
.next { right: var(--space-2); }

@media (max-width: 40rem) {
  .arrow { width: 2.25rem; height: 2.25rem; font-size: 1.5rem; }
  .filename { display: none; }
}
